import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme: any) => ({
  w100: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
  },
  input: {
    background: "#FFFFFF",
    height: "50px",
    borderRadius: "10px!important",
    "&.Mui-error": {
      border: "1px solid red",
    },
  },
  row: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  portraitItem: {
    boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.15)",
    background: "#FFFFFF",
    margin: "0 12px",
    padding: "10px",
    marginBottom: "30px",
    height: "277px",
    width: "95%",
    maxWidth: "100%",
    transition: "0.3s",
    "&.active": {
      border: "2.73px solid #245fad",
    },
    "&:hover": {
      boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.3)",
    },
    [theme.breakpoints.down("767")]: {
      height: 220,
      margin: "12px 6px",
    },
    [theme.breakpoints.down("575")]: {
      height: 210,
    },
  },
  landscapeItem: {
    boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.15)",
    background: "#FFFFFF",
    margin: "0 12px",
    padding: "10px",
    height: "167px",
    marginBottom: "30px",
    boxSizing: "border-box",
    border: "2px solid transparent",
    width: "95%",
    maxWidth: "100%",
    transition: "0.3s",
    "&.active": {
      border: "2.73px solid #245fad",
    },
    "&:hover": {
      boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.3)",
    },
    [theme.breakpoints.down("767")]: {
      margin: "12px 6px",
    },
    [theme.breakpoints.down("575")]: {
      margin: "12px 6px",
      height: "150px",
      padding: "8px 17px 8px",
    },
  },
  itemDetailWrapper: {
    gridColumn: "1 / -1",
    width: "99%",
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
    borderRadius: "10px",
    background: "#FFFFFF",
    margin: "0 12px 60px 12px",
    height: "415px",
    [theme.breakpoints.down("767")]: {
      height: "530px",
      margin: "10px 6px 20px 6px",
    },
    [theme.breakpoints.down("575")]: {
      height: "auto",
    },
    [theme.breakpoints.down("430")]: {
      margin: "10px 6px 20px 3px",
    },
  },
  itemDetailRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: "100%",
    [theme.breakpoints.down("767")]: {
      display: "flex",
      flexDirection: "column",
    },
  },
  imgArea: {
    width: "50%",
    textAlign: "center",
    "& img": {
      maxHeight: "339px",
      maxWidth: "339px",
      objectFit: "contain",
      [theme.breakpoints.down("575")]: {
        maxWidth: "100%",
        width: "80%",
        margin: "auto",
      },
    },
    [theme.breakpoints.down("991")]: {
      width: "60%",
    },
    [theme.breakpoints.down("767")]: {
      width: "auto",
      marginTop: 10,
      order: 2,
    },
  },
  textArea: {
    width: "50%",
    paddingLeft: "13%",
    [theme.breakpoints.down("991")]: {
      paddingLeft: "3%",
    },
    [theme.breakpoints.down("767")]: {
      width: "auto",
      textAlign: "center",
      order: 1,
    },
  },
  itemTitle: {
    fontWeight: 500,
    fontSize: "24px",
    lineHeight: "33px",
    color: "#202020",
    [theme.breakpoints.down("767")]: {
      marginTop: 15,
    },
  },
  itemPrice: {
    "& span:not(.value)": {
      fontSize: "20px",
      lineHeight: "27px",
      fontWeight: "bold",
      color: "#202020",
    },
    "& .value": {
      fontSize: "23px",
      lineHeight: "31px",
      fontWeight: "bold",
      color: "#202020",
    },
  },
  innerCardItemImgArea: {
    width: "31%",
    "& img": {
      width: "100%",
      height: "198px",
      objectFit: "contain",
    },
    [theme.breakpoints.down("767")]: {
      order: 2,
      width: "auto",
    },
    [theme.breakpoints.down("575")]: {
      width: "90%",
      margin: "0 auto",
    },
  },
  innerCardItemTextArea: {
    width: "29%",
    textAlign: "left",
    paddingLeft: "23px",
    [theme.breakpoints.down("767")]: {
      order: 1,
      width: "auto",
      textAlign: "center",
    },
  },
  innerCardItemTitle: {
    fontSize: "24px",
    fontWeight: "bold",
    lineHeight: "33px",
    color: "#202020",
    marginBottom: "8px",
    [theme.breakpoints.down("767")]: {
      width: 300,
    },
    [theme.breakpoints.down("575")]: {
      width: 220,
    },
  },
  innerCardItemDescription: {
    fontSize: "16px",
    lineHeight: "22px",
    color: "#202020",
    [theme.breakpoints.down("767")]: {
      display: "none",
    },
  },
  additionalInnerCardItemDescription: {
    display: "none",
    fontSize: "16px",
    lineHeight: "22px",
    color: "#202020",
    [theme.breakpoints.down("767")]: {
      display: "block",
      order: 3,
      margin: "5px 15px 8px",
      textAlign: "center",
    },
  },
  innerCardItemButtonsTitle: {
    width: "100%",
    fontWeight: "bold",
    fontSize: "20px",
    lineHeight: "27px",
    color: "#202020",
    marginBottom: "29px",
    textAlign: "center",
  },
  innerCardItemButtonsRow: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("1100")]: {
      flexWrap: "wrap",
    },
    [theme.breakpoints.down("767")]: {
      flexWrap: "unset",
    },
    [theme.breakpoints.down("430")]: {
      justifyContent: "space-around",
    },
    "& button": {
      width: "31.5%",
      height: "59px",
      position: "relative",
      marginRight: "10px",
      background: "#FFFFFF",
      border: "2px solid #9CA3AF",
      borderRadius: "15px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      cursor: "pointer",
      [theme.breakpoints.down("1100")]: {
        marginTop: 5,
      },
      [theme.breakpoints.down("767")]: {
        width: "31%",
      },
      [theme.breakpoints.down("575")]: {
        height: 47,
        marginRight: 9,
        width: "28%",
      },
      [theme.breakpoints.down("435")]: {
        width: "25%",
        marginRight: 10,
      },
      "& .price": {
        fontSize: "18px",
        fontWeight: "bold",
        lineHeight: "31px",
        color: "#202020",
        [theme.breakpoints.down("991")]: {
          fontSize: 16,
        },
        [theme.breakpoints.down("767")]: {
          width: 84,
          fontSize: 16,
        },
        [theme.breakpoints.down("575")]: {
          fontSize: 14,
        },
      },
      "&.active": {
        border: "3px solid #245fad",
        "& svg": {
          position: "absolute",
          right: "-12px",
          top: "-12px",
          zIndex: "2",
          background: "#FFFFFF",
        },
      },
    },
    [theme.breakpoints.down("575")]: {
      "& button": {
        width: "auto",
      },
    },
  },
  innerCardItemButtonsArea: {
    width: "40%",
    [theme.breakpoints.down("767")]: {
      order: 4,
      width: "80%",
    },
  },
  buttonsArea: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "33px",
    "& button": {
      borderRadius: "10px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "51px",
      fontWeight: 500,
      fontSize: "16px",
      lineHeight: "22px",
      transition: "0.3s",
      cursor: "pointer",
    },
    "& .skip-btn": {
      background: "#FFFFFF",
      border: "1px solid #245fad",
      color: "#245fad",
      width: "136px",
      marginRight: "15px",
      "&:hover": {
        background: "#245fad",
        color: "white",
      },
      [theme.breakpoints.down("767")]: {
        width: 190,
      },
      [theme.breakpoints.down("575")]: {
        width: 150,
      },
      [theme.breakpoints.down("430")]: {
        width: 130,
      },
    },
    "& .select-btn": {
      background: "#245fad",
      color: "white",
      width: "136px",
      border: "1px solid #245fad",
      [theme.breakpoints.down("767")]: {
        width: 190,
      },
      [theme.breakpoints.down("575")]: {
        width: 150,
      },
      [theme.breakpoints.down("430")]: {
        width: 130,
      },
    },
    "&.second-buttons-area": {
      display: "none",
    },
    [theme.breakpoints.down("767")]: {
      display: "none",
      "&.second-buttons-area": {
        display: "flex",
        order: 5,
        marginTop: 15,
      },
    },
  },
  secondButtonsArea: {
    display: "none",
    [theme.breakpoints.down("767")]: {
      display: "flex",
      order: 3,
      width: "85%",
      paddingBottom: 15,
      "& button": {
        width: "206px",
      },
    },
    [theme.breakpoints.down("575")]: {
      "&.select-or-skip-buttons-row": {
        width: "94%",
      },
    },
    [theme.breakpoints.down("390")]: {
      "&.select-or-skip-buttons-row": {
        "& button": {
          width: "135px!important",
        },
      },
    },
  },
}));

export default useStyles;
